import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["searchInput", "unqualifiedCheckbox", "inactiveCheckbox"]

  connect() {
    console.log("ClientListController connected")
    this.debouncedSearch = this.debounce(this.submitForm.bind(this), 150)
  }

  view(event) {
    event.preventDefault()
    // Navigate to the client using advance to create proper history entry
    Turbo.visit(event.params.url, { action: 'advance' })
  }

  toggleFilter(event) {
    // Handle checkbox changes - submit form immediately
    event.target.form.submit()
  }

  preventSubmit(event) {
    // Prevent form submission - we handle search via AJAX
    event.preventDefault()
  }

  handleKeydown(event) {
    // Prevent form submission on Enter key
    if (event.key === 'Enter') {
      event.preventDefault()
    }
  }

  filterClients(event) {
    const searchTerm = event.target.value
    const form = event.target.closest('form')
    
    if (form) {
      // Always trigger server-side search across all pages - no client-side filtering
      this.debouncedSearch()
    }
  }

  submitForm() {
    const form = this.element.querySelector('form')
    if (form) {
      // Remove any existing page parameter when searching
      // since search results should start from page 1
      const pageInput = form.querySelector('input[name="page"]')
      if (pageInput) {
        pageInput.remove()
      }
      
      // Create FormData from the form
      const formData = new FormData(form)
      const params = new URLSearchParams(formData)
      
      // Use the current page's path to preserve route context (like /clients/inactive)
      const currentPath = window.location.pathname
      
      // Make a fetch request to get turbo_stream response
      fetch(`${currentPath}?${params}`, {
        method: 'GET',
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.text())
      .then(html => {
        // Use Turbo to process the turbo_stream response
        Turbo.renderStreamMessage(html)
      })
      .catch(error => {
        console.error('Search request failed:', error)
      })
    }
  }

  debounce(func, wait) {
    let timeout
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout)
        func(...args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }
}
